"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9232],{

/***/ 28991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_AddToCartSelector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(19154);
// EXTERNAL MODULE: ./node_modules/react-star-ratings/build/index.js
var build = __webpack_require__(39503);
// EXTERNAL MODULE: ./src/components/product/FitmentVerification.jsx
var FitmentVerification = __webpack_require__(58765);
// EXTERNAL MODULE: ./src/services/index.js
var services = __webpack_require__(59327);
// EXTERNAL MODULE: ./src/components/category/Reviews/index.jsx + 2 modules
var Reviews = __webpack_require__(61874);
// EXTERNAL MODULE: ./src/components/checkout/Payment/AffirmFunctions.js
var AffirmFunctions = __webpack_require__(17747);
// EXTERNAL MODULE: ./src/components/loading.jsx
var loading = __webpack_require__(38640);
;// CONCATENATED MODULE: ./src/components/product/CampaignHypherlink.jsx


var CampaignHypherlink = function(props) {
    var _campaign = props.campaign, redirectURL = _campaign.redirectURL, campaignText = _campaign.campaignText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: "campaign-hypherlink",
        target: "_blank",
        href: redirectURL,
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: campaignText
        })
    });
};
/* harmony default export */ var product_CampaignHypherlink = (CampaignHypherlink);

// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(2277);
;// CONCATENATED MODULE: ./src/components/product/AddToCartSelector.jsx
























var formatCurrency = __webpack_require__(9180);

var options = [
    {
        value: "Price",
        label: "Price"
    },
    {
        value: "DistanceMiles",
        label: "Distance"
    },
    {
        value: "Rating",
        label: "Rating"
    }, 
];
var customStyles = {
    menuList: function(provided, state) {
        return (0,_object_spread/* default */.Z)({}, provided);
    },
    control: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "45px",
            borderRadius: "3px",
            border: "1px solid #fff",
            backgroundColor: "#fff !important"
        });
    },
    valueContainer: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "45px",
            padding: "0 6px"
        });
    },
    input: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            margin: "0px"
        });
    },
    indicatorsContainer: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "45px"
        });
    }
};
var AddToCartSelector = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AddToCartSelector, Component);
    var _super = (0,_create_super/* default */.Z)(AddToCartSelector);
    function AddToCartSelector(props) {
        (0,_class_call_check/* default */.Z)(this, AddToCartSelector);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "setSelectedLocation", function(e) {
            // Pop to front of array
            e.Index = _this.state.UserLocationIndexLookup;
            _this.renderValue(e);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "getLocations", function(e, index) {
            _this.setState({
                selectedLocationArray: e,
                UserLocationIndexLookup: index,
                modalOpen: true
            });
        });
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "renderValue", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _this1.setState({
                        selectedService: e.ServiceId,
                        selectedProviderId: e.ProviderId
                    });
                    _this1.props.setSelectedProvider({
                        providerId: e.ProviderId,
                        serviceId: e.ServiceId
                    });
                    if (_this1.props.isCart) {
                        _this1.props.updateSelectedProvider(_this1.props.item.id, e.provider, e.ServiceId);
                    }
                    // FIXME: Forcing parent component to re render once store gets new state
                    setTimeout(function() {
                        _this1.props.forceState();
                    }, 0);
                    return [
                        2
                    ];
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }());
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onOpenModal", function() {
            _this.setState({
                modalOpen: true
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onCloseModal", function() {
            _this.setState({
                modalOpen: false
            });
        });
        _this.state = {
            open: false,
            quantity: 1,
            selectedProviderId: 0,
            selectedLocation: 0,
            selectedLocationArray: [],
            UserLocationIndexLookup: 0,
            selectedService: 0,
            integratedLocationsHeight: null,
            modalOpen: false,
            sortBy: {
                value: "",
                label: ""
            },
            addingToCart: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(AddToCartSelector, [
        {
            key: "showIntegratedLocations",
            value: function showIntegratedLocations(value) {
                this.setState({
                    showIntegratedLocations: value
                });
            }
        },
        {
            key: "callNumber",
            value: function callNumber(number) {
                //  Add Analytics to Post Out CALL HERE or TRACKING ( TO-DO )
                window.open("tel:".concat(number));
            }
        },
        {
            key: "LinkHref",
            value: function LinkHref(href) {
                if (href.startsWith("http")) {
                    // External Affliate URL
                    // TODO: Add Analytics to Post Out URL HERE or TRACKING
                    window.location.href = href;
                } else {
                    // Client Side Site URL
                    router_default().push(href);
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    initialCartQty: this.props.cartlist && this.props.cartlist.cart.length > 0 ? this.props.cartlist.cart[0].qty : 0
                });
                var id = "singleItemAffirmProposition_".concat(this.props.item.id);
                var item = this.props.item;
                setTimeout(function() {
                    (0,AffirmFunctions/* initSingleLineProposition */.vT)(affirm, item, id);
                    affirm.ui.ready(function() {
                        affirm.ui.refresh();
                    });
                }, 0);
            }
        },
        {
            key: "BuyNow",
            value: function BuyNow(item, quantity) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setState({
                                    addingToCart: true
                                });
                                return [
                                    4,
                                    _this.props.addToCartClicked(item, quantity > 0 ? quantity : 1)
                                ];
                            case 1:
                                _state.sent(); // 1 is minimum quantity
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, cartlist = _props.cartlist, optionalServiceArray = _props.optionalServiceArray, serviceArray = _props.serviceArray, selectedServiceIndex = _props.selectedServiceIndex, item = _props.item, addToWishlistClicked = _props.addToWishlistClicked, compact = _props.compact, dontShowBuyButton = _props.dontShowBuyButton, providerLoading = _props.providerLoading, isCart = _props.isCart, symbol = _props.symbol, provider = _props.provider, reviews = _props.reviews;
                var latestCartQty = cartlist && cartlist.cart.length > 0 ? cartlist.cart[0].qty : 0;
                if (serviceArray.length == 0) {
                    return "";
                }
                var sortedOptions = this.state.sortBy.value === "Rating" ? sortBy_default()(this.state.selectedLocationArray, [
                    this.state.sortBy.value
                ]).reverse() : sortBy_default()(this.state.selectedLocationArray, [
                    this.state.sortBy.value
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "add-to-cart-selector ".concat(compact ? "compact" : ""),
                    ref: function(locationsContainer) {
                        return _this.locationsContainer = locationsContainer;
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-options-container",
                            children: optionalServiceArray.length > 0 ? optionalServiceArray.map(function(option, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: option.isShowPriceOnly && "show-price-only",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        disabled: option.isShowPriceOnly && "show-price-only",
                                        className: "btn ".concat(index === _this.props.selectedServiceIndex ? "active" : ""),
                                        onClick: function(e) {
                                            _this.renderValue({
                                                Index: option.Index,
                                                ProviderId: option.Locations[0].ProviderId,
                                                ServiceId: option.ServiceId,
                                                provider: option.Locations[0]
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "primary",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "icon",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "checked far fa-check-circle"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "unchecked far fa-circle"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "content",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "service-description",
                                                                children: option.ServiceDescription
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "about-location",
                                                                children: [
                                                                    option.ServiceLabel,
                                                                    option.FeeMessage ? " - ".concat(option.FeeMessage) : ""
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "about-location",
                                                                children: option.Name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "about-location",
                                                                children: option.ProviderMessage
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "reviews-cont",
                                                                children: reviews && (reviews === null || reviews === void 0 ? void 0 : reviews.stats) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "about-location star-details",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.Z, {
                                                                            numberOfStars: 5,
                                                                            rating: parseFloat(reviews.stats.average_rating),
                                                                            starDimension: "12px",
                                                                            starSpacing: "0",
                                                                            starRatedColor: "#FF9966",
                                                                            starEmptyColor: "grey"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "numerical-rating-container",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "numerical-rating ml-1",
                                                                                    children: [
                                                                                        "(",
                                                                                        reviews.stats.average_rating,
                                                                                        ")"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "numerical-rating ml-1",
                                                                                    children: [
                                                                                        reviews.stats.total_reviews,
                                                                                        " Reviews"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            serviceArray[index].ServiceId != 2 && serviceArray[index].ServiceId != 3 && serviceArray[index].ServiceId != 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "secondary",
                                                onClick: function(e) {
                                                    return _this.getLocations(serviceArray[index].Locations, selectedServiceIndex);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        option.ImageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "provider-logo",
                                                            src: option.ImageUrl,
                                                            alt: ""
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-map-marked-alt",
                                                            children: " "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                            className: "free-installation",
                                                            children: " Change"
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "secondary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    onClick: function() {
                                                        return _this.props.showProviderDetails();
                                                    },
                                                    children: [
                                                        !providerLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: option.iconClassName ? option.iconClassName : "fas fa-shipping-fast"
                                                        }),
                                                        providerLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-circle-notch fa-spin"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                            className: "free-installation",
                                                            children: [
                                                                !providerLoading && "Details",
                                                                providerLoading && "Loading"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, index)
                                }, index);
                            }) : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "prices",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "affirm-as-low-as",
                                "data-page-type": "product",
                                "data-amount": this.props.item.price * 100
                            })
                        }),
                        !dontShowBuyButton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "add-to-cart-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "primary",
                                    children: [
                                        !compact && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "quantity-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                disabled: serviceArray[this.props.selectedServiceIndex].DisableCart,
                                                type: "number",
                                                name: "quantity",
                                                min: "1",
                                                max: "99",
                                                placeholder: this.state.quantity > 0 ? this.state.quantity : 1,
                                                onChange: function(e) {
                                                    return _this.setState({
                                                        quantity: e.target.value
                                                    });
                                                },
                                                className: "form-control input-number"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            disabled: serviceArray[this.props.selectedServiceIndex].DisableButton || this.props.isLoading,
                                            className: "btn cart ".concat((serviceArray[this.props.selectedServiceIndex].DisableButton || this.props.isLoading) && "disabled"),
                                            onClick: function() {
                                                var ref;
                                                return serviceArray[_this.props.selectedServiceIndex].ServiceId == 5 ? _this.callNumber(((ref = serviceArray[_this.props.selectedService]) === null || ref === void 0 ? void 0 : ref.PhoneNumber) ? serviceArray[_this.props.selectedService].PhoneNumber : "8002288379") : serviceArray[_this.props.selectedServiceIndex].ServiceId == 10 ? _this.LinkHref(serviceArray[_this.props.selectedServiceIndex].ServiceURL) : _this.BuyNow(item, _this.state.quantity);
                                            },
                                            children: [
                                                !serviceArray[this.props.selectedServiceIndex].DisableCart && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        this.state.initialCartQty === latestCartQty && this.state.addingToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: serviceArray[this.props.selectedServiceIndex].iconClassName ? serviceArray[this.props.selectedServiceIndex].iconClassName : "fas fa-cart-plus"
                                                        }),
                                                        serviceArray[this.props.selectedServiceIndex].ButtonLabel
                                                    ]
                                                }),
                                                serviceArray[this.props.selectedServiceIndex].DisableCart && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: serviceArray[this.props.selectedServiceIndex].iconClassName ? serviceArray[this.props.selectedServiceIndex].iconClassName : "fas fa-phone-alt"
                                                        }),
                                                        serviceArray[this.props.selectedServiceIndex].ButtonLabel
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                item.fitmentMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "alert alert-primary mt-2",
                                    role: "alert",
                                    children: item.fitmentMessage
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        item.campaigns.map(function(item, index) {
                            if (item.campaignType === 3) {
                                if (isCart) {
                                    return item.discountAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(product_CampaignHypherlink, {
                                        campaign: item
                                    }, index);
                                } else {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_CampaignHypherlink, {
                                        campaign: item
                                    }, index);
                                }
                            }
                        }),
                        this.props.showFitment && (this.props.item.categoryId === 2 || this.props.item.categoryId === 205712) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FitmentVerification/* default */.Z, {
                            formTitle: "",
                            subtitle: "Verify fitment with your vehicle",
                            type: "single-product-fitment",
                            idToCompare: item.bigCommerceId,
                            categorySlug: item.category.urlSlug
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_modal_esm/* default */.Z, {
                            classNames: {
                                modal: "change-location-modal"
                            },
                            open: this.state.modalOpen,
                            onClose: this.onCloseModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "location-items-integrated",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "Available Locations"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "button-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: "btn",
                                                            onClick: function() {
                                                                return _this.setState({
                                                                    modalOpen: false
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-times",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                "Close"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "controls",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "title",
                                                        children: "Sort By: "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                                        styles: customStyles,
                                                        placeholder: "Default",
                                                        options: options,
                                                        onChange: function(value) {
                                                            return _this.setState({
                                                                sortBy: value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "body",
                                        children: sortedOptions.map(function(locations, index) {
                                            var msrp = locations.msrp ? locations.msrp : Math.round(locations.Price * 1.15, 2);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item ".concat(provider.providerId === locations.ProviderId ? "selected" : ""),
                                                onClick: function() {
                                                    _this.setState({
                                                        modalOpen: false
                                                    });
                                                    _this.setSelectedLocation(locations);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "selected-label",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fas fa-check"
                                                            }),
                                                            " Selected"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "section first",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "content",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "body",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-map-marker-alt mr-1"
                                                                                }),
                                                                                "".concat((0,services/* getDistanceMessage */.$h)(locations.DistanceMiles))
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: locations.Address1
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "".concat(locations.City, ", ").concat(locations.State, " , ").concat(locations.ZipPostalCode)
                                                                        })
                                                                    ]
                                                                }),
                                                                provider.providerId !== locations.ProviderId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "footer",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "footer-item",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            className: "btn location",
                                                                            onClick: function() {
                                                                                _this.setState({
                                                                                    modalOpen: false
                                                                                });
                                                                                _this.setSelectedLocation(locations);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-location"
                                                                                }),
                                                                                "Select Location"
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "section second",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "info",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        width: "64px",
                                                                        src: locations.ImageUrl,
                                                                        alt: ""
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: locations.Name
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "price",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "ex-price",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("del", {
                                                                            children: [
                                                                                symbol,
                                                                                formatCurrency(msrp)
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "price",
                                                                        children: [
                                                                            symbol,
                                                                            formatCurrency(locations.Price)
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "rating",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.Z, {
                                                                                numberOfStars: 5,
                                                                                rating: parseFloat(reviews.stats.average_rating),
                                                                                starDimension: "15px",
                                                                                starSpacing: "0",
                                                                                starRatedColor: "#FF9966",
                                                                                starEmptyColor: "grey"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                children: [
                                                                                    "(",
                                                                                    reviews.stats.average_rating,
                                                                                    ") - ",
                                                                                    reviews.stats.total_reviews,
                                                                                    " ",
                                                                                    "Reviews"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "btn location mobile-only",
                                                        onClick: function() {
                                                            _this.setState({
                                                                modalOpen: false
                                                            });
                                                            _this.setSelectedLocation(locations);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fas fa-location"
                                                            }),
                                                            "Select Location"
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return AddToCartSelector;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        products: state.category.products
    };
};
/* harmony default export */ var product_AddToCartSelector = ((0,es/* connect */.$j)(mapStateToProps, null)(AddToCartSelector));


/***/ }),

/***/ 83922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_star_ratings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39503);



var formatCurrency = __webpack_require__(9180);
var ProviderDetails = function(param) {
    var show = param.show, data = param.data, close = param.close, width = param.width, height = param.height, left = param.left, optionalServiceArray = param.optionalServiceArray, horizontal = param.horizontal, specificIndex = param.specificIndex, onProductPage = param.onProductPage, reviews = param.reviews;
    var inlineStylesNormal = {
        width: width ? width : "100%",
        height: height ? height : "auto",
        left: left ? left : "0"
    };
    var inlineStylesSpecific = {
        width: width ? width : "100%",
        height: height ? height : "auto",
        right: left ? left : "0"
    };
    if (!data || !data.googlePlacesData) {
        return "";
    }
    var providerServices = data.providerServices;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "provider-details\n      ".concat(show ? "active" : "", "\n      ").concat(horizontal ? "horizontal" : "", "\n      ").concat(onProductPage ? "on-product-page" : "", "\n      ").concat(specificIndex ? "specific" : ""),
        style: !specificIndex ? inlineStylesNormal : inlineStylesSpecific,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "inner",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "header mt-0",
                    children: [
                        data.locationImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: data.locationImageUrl,
                            alt: "location"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            children: data && data.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "btn",
                            onClick: function() {
                                return close();
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "fas fa-times"
                                }),
                                " Close"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
                    className: "table",
                    children: optionalServiceArray.map(function(service, index) {
                        var row = providerServices.findIndex(function(x) {
                            return x.serviceId === service.ServiceId;
                        });
                        var mileageCharge = null;
                        if (row >= 0) {
                            mileageCharge = formatCurrency(providerServices[row].mileageCharge);
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                            children: [
                                service.ServiceDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: service.ServiceDescription
                                    })
                                }),
                                service.ServiceLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: service.ServiceLabel
                                    })
                                }),
                                service.FeeMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: service.FeeMessage
                                    })
                                }),
                                service.ProviderMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: service.ProviderMessage
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: mileageCharge ? "Mileage Fees: $".concat(mileageCharge) : ""
                                    })
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: "Reviews"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "rating mb-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_star_ratings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            numberOfStars: 5,
                            rating: parseFloat(reviews.stats.average_rating),
                            starDimension: "16px",
                            starSpacing: "0",
                            starRatedColor: "#FF9966",
                            starEmptyColor: "grey"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "(",
                                reviews.stats.average_rating,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                " ",
                                reviews.stats.total_reviews,
                                " Reviews"
                            ]
                        })
                    ]
                }),
                reviews ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "testimonials",
                    children: reviews.reviews.map(function(data, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                            className: "blockquote",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-0",
                                    children: data.comments
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "blockquote-footer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "mr-1",
                                            children: [
                                                data.reviewer.first_name,
                                                " ",
                                                data.reviewer.last_name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_star_ratings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            numberOfStars: 5,
                                            rating: data.rating,
                                            starDimension: "14px",
                                            starSpacing: "0",
                                            starRatedColor: "#FF9966",
                                            starEmptyColor: "grey"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-1",
                                    children: data.date
                                })
                            ]
                        }, index);
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProviderDetails);


/***/ }),

/***/ 84933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getProductServicesArray; }
/* harmony export */ });
/* harmony import */ var format_currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9180);
/* harmony import */ var format_currency__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(format_currency__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25631);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96981);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59327);




function getProductServicesArray(item, selectedServiceIndex, provider, externalrequest) {
    var FeeMessage = function FeeMessage(location) {
        var FeeMessage1 = "Fee: $" + format_currency__WEBPACK_IMPORTED_MODULE_0___default()(location.Fee);
        if (location.Fee == 0 || location.Fee == undefined) {
            FeeMessage1 = "";
        }
        return FeeMessage1;
    };
    var DeliveryMinutes = function DeliveryMinutes(location) {
        var DeliveryMessage = "Within 24 hours";
        // If Mobile Driver Offline or Non Mobile Location use Delivery ETA Message
        if (location.OnFleetStatus ? location.OnFleetStatus : 0 == 0) {
            DeliveryMessage = location.ETAMessage ? location.ETAMessage : DeliveryMessage;
        }
        if (location.OnFleetStatus ? location.OnFleetStatus :  false && 0) {
            var leadTime = location.LeadTimeMinutes ? location.LeadTimeMinutes + 40 : 90; // HardCode add to ETA for now.
            var deliveryMinutes = leadTime + Math.ceil(location.DistanceMiles * 1.5);
            if (deliveryMinutes > 0) {
                DeliveryMessage = "est. ".concat(deliveryMinutes, " min*");
            }
        }
        return DeliveryMessage;
    };
    var serviceArray = [];
    var optionalServiceArray = [];
    var i = 0;
    if (item.priceOnlyLocations && item.priceOnlyLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.priceOnlyLocations[0].ServiceId,
            ServiceDescription: "Please Select Service Level Below:",
            ServiceLabel: "Availabile in: ".concat(DeliveryMinutes(item.priceOnlyLocations[0])),
            ServiceURL: "Schedule",
            Locations: item.priceOnlyLocations,
            iconClassName: "fas fa-car-mechanic",
            ProviderMessage: item.priceOnlyLocations[0].Message,
            DisableCart: false,
            DisableButton: true,
            ButtonLabel: "Request Service",
            FeeMessage: item.priceOnlyLocations[0].Fee ? "".concat(FeeMessage(item.roadsideLocations[0])) : "",
            Fee: item.priceOnlyLocations[0].Fee ? item.priceOnlyLocations[0].Fee : 0,
            isShowPriceOnly: true
        });
        i++;
    }
    if (item.shippingLocations && item.shippingLocations.length > 0) {
        var quantityLabel = quantityLabelFunc(item.shippingLocations[0]);
        serviceArray.push({
            Index: i,
            ServiceId: item.shippingLocations[0].ServiceId,
            ServiceDescription: item.shippingLocations[0].ServiceDescription,
            ServiceLabel: "From: ".concat(item.shippingLocations[0].City, ", ").concat(item.shippingLocations[0].State, " ").concat(quantityLabel),
            ProviderMessage: item.shippingLocations[0].Message,
            Locations: item.shippingLocations,
            ServiceURL: "",
            iconClassName: "fas fa-truck-loading",
            DisableCart: false,
            ButtonLabel: "Buy Now",
            FeeMessage: null,
            Fee: item.shippingLocations[0].Fee ? item.shippingLocations[0].Fee : 0
        });
        i++;
    }
    if (item.installLocations && item.installLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.installLocations[0].ServiceId,
            ServiceDescription: "".concat(item.installLocations[0].ServiceDescription, " in ").concat(item.installLocations[0].City),
            ServiceLabel: "".concat((0,_services__WEBPACK_IMPORTED_MODULE_1__/* .getDistanceMessage */ .$h)(item.installLocations[0].DistanceMiles)),
            ServiceURL: "View Locations",
            Name: item.installLocations[0].Name,
            ImageUrl: item.installLocations[0].ImageUrl,
            ProviderMessage: item.installLocations[0].Message,
            Locations: item.installLocations,
            iconClassName: "fas fa-car-mechanic",
            DisableCart: false,
            ButtonLabel: "Schedule Install",
            FeeMessage: "".concat(FeeMessage(item.installLocations[0]), " Installation"),
            Fee: item.installLocations[0].Fee ? item.installLocations[0].Fee : 0
        });
        i++;
    }
    if (item.repairLocations && item.repairLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.repairLocations[0].ServiceId,
            ServiceDescription: item.repairLocations[0].ServiceDescription,
            ServiceLabel: "".concat((0,_services__WEBPACK_IMPORTED_MODULE_1__/* .getDistanceMessage */ .$h)(item.repairLocations[0].DistanceMiles)),
            ServiceURL: "View Locations",
            Locations: item.repairLocations,
            Name: item.repairLocations[0].Name,
            ImageUrl: item.repairLocations[0].ImageUrl,
            ProviderMessage: item.repairLocations[0].Message,
            iconClassName: "fas fa-tools",
            DisableCart: false,
            ButtonLabel: "Add Repair",
            ServiceMessage: item.repairLocations[0].Message,
            FeeMessage: "".concat(FeeMessage(item.repairLocations[0]), " Repair"),
            Fee: item.repairLocations[0].Fee ? item.repairLocations[0].Fee : 0
        });
        i++;
    }
    if (item.mobileRepairLocations && item.mobileRepairLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.mobileRepairLocations[0].ServiceId,
            ServiceDescription: item.mobileRepairLocations[0].ServiceDescription,
            ServiceLabel: "".concat((0,_services__WEBPACK_IMPORTED_MODULE_1__/* .getDistanceMessage */ .$h)(item.mobileRepairLocations[0].DistanceMiles)),
            ServiceURL: "Schedule",
            Locations: item.mobileRepairLocations,
            Name: "",
            ImageUrl: item.mobileRepairLocations[0].ImageUrl,
            ProviderMessage: item.mobileRepairLocations[0].Message,
            iconClassName: "fas fa-car-mechanic",
            DisableCart: false,
            ButtonLabel: "Add Mobile Repair",
            ServiceMessage: item.mobileRepairLocations[0].Message
        });
        i++;
    }
    if (item.pickupLocations && item.pickupLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.pickupLocations[0].ServiceId,
            ServiceDescription: "".concat(item.pickupLocations[0].ServiceDescription, " in ").concat(item.pickupLocations[0].City),
            ServiceLabel: "".concat((0,_services__WEBPACK_IMPORTED_MODULE_1__/* .getDistanceMessage */ .$h)(item.pickupLocations[0].DistanceMiles)),
            ServiceURL: "View Locations",
            Locations: item.pickupLocations,
            iconClassName: "fas fa-hand-holding-box",
            ImageUrl: item.pickupLocations[0].ImageUrl,
            Name: item.pickupLocations[0].Name,
            ProviderMessage: item.pickupLocations[0].Message,
            DisableCart: false,
            ButtonLabel: "Reserve Item for Pickup",
            ServiceMessage: item.pickupLocations[0].Message,
            FeeMessage: "".concat(FeeMessage(item.pickupLocations[0]), " Pickup"),
            Fee: item.pickupLocations[0].Fee ? item.pickupLocations[0].Fee : 0
        });
        i++;
    }
    if (item.deliveryLocations && item.deliveryLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.deliveryLocations[0].ServiceId,
            ServiceDescription: "".concat(item.deliveryLocations[0].ServiceDescription, " ").concat(item.deliveryLocations[0].ServiceId == 2 ? " - No Install" : ""),
            ServiceLabel: "".concat(DeliveryMinutes(item.deliveryLocations[0])),
            ServiceURL: "Schedule",
            Locations: item.deliveryLocations,
            iconClassName: "fas fa-car-mechanic",
            ProviderMessage: item.deliveryLocations[0].Message,
            DisableCart: false,
            ButtonLabel: "Schedule Install",
            FeeMessage: "".concat(FeeMessage(0)),
            Fee: item.deliveryLocations[0].Fee ? 0 : 0
        });
        i++;
    }
    if (item.deliveryOnlyLocations && item.deliveryOnlyLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.deliveryOnlyLocations[0].ServiceId,
            ServiceDescription: "".concat(item.deliveryOnlyLocations[0].ServiceDescription, " ").concat(item.deliveryOnlyLocations[0].ServiceId == 2 ? "" : ""),
            ServiceLabel: "".concat(DeliveryMinutes(item.deliveryOnlyLocations[0])),
            ServiceURL: "Schedule",
            Locations: item.deliveryOnlyLocations,
            iconClassName: "fas fa-truck",
            ProviderMessage: item.deliveryOnlyLocations[0].Message,
            DisableCart: false,
            ButtonLabel: externalrequest && externalrequest.request ? "".concat(externalrequest.request.serviceNeeded, " Upgrade") : "Schedule Delivery",
            FeeMessage: "".concat(FeeMessage(0)),
            Fee: item.deliveryOnlyLocations[0].Fee ? 0 : 0
        });
        i++;
    }
    if (item.roadsideLocations && item.roadsideLocations.length > 0) {
        serviceArray.push({
            Index: i,
            ServiceId: item.roadsideLocations[0].ServiceId,
            ServiceDescription: "".concat(item.roadsideLocations[0].ServiceDescription),
            ServiceLabel: "Availabile in: ".concat(DeliveryMinutes(item.roadsideLocations[0])),
            ServiceURL: "Schedule",
            Locations: item.roadsideLocations,
            iconClassName: "far fa-ambulance",
            ProviderMessage: item.roadsideLocations[0].Message,
            DisableCart: false,
            ButtonLabel: "Request Service",
            FeeMessage: item.roadsideLocations[0].Fee ? "".concat(FeeMessage(item.roadsideLocations[0])) : "",
            Fee: item.roadsideLocations[0].Fee ? item.roadsideLocations[0].Fee : 0
        });
        i++;
    }
    var phoneNumber = "";
    var googleNumber = "";
    // No Service Items Check for Call Only Locations ( Note UI should have Button Change based on  Service - Example.
    // Call Only is simply a Tel Link, INstall and Shipping Add to Cart, Roadside different Checkout Process)
    var callCount = item.callLocations ? item.callLocations.length : 0;
    if (callCount > 0) {
        if (item.callLocations[0].PhoneNumber) {
            googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_2__/* .findPhoneNumbersInText */ .t)(item.callLocations[0].PhoneNumber, "US");
            phoneNumber = item.callLocations[0].PhoneNumber;
            if (googleNumber.length > 0) {
                googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_3__/* .parsePhoneNumber */ .S)(googleNumber[0].number.number);
                phoneNumber = googleNumber.formatNational();
                googleNumber = googleNumber.getURI();
            }
        }
        serviceArray.push({
            Index: i,
            ServiceId: item.callLocations[0].ServiceId,
            ServiceDescription: item.callLocations[0].ServiceDescription,
            ServiceLabel: "From: ".concat(item.callLocations[0].City, ", ").concat(item.callLocations[0].State),
            Locations: item.callLocations,
            ServiceURL: "Please Call  ".concat(item.callLocations[0].PhoneNumber, " ").concat((0,_services__WEBPACK_IMPORTED_MODULE_1__/* .getDistanceMessage */ .$h)(item.callLocations[0].DistanceMiles)),
            iconClassName: "fas fa-phone",
            Fee: 0,
            Name: item.callLocations[0].Name,
            ImageUrl: item.callLocations[0].ImageUrl,
            ProviderMessage: item.callLocations[0].Message,
            Reviews: null,
            DisableCart: true,
            FeeMessage: "Please Call",
            ButtonLabel: "Please Click Button to Call",
            PhoneNumber: phoneNumber
        });
        i++;
    }
    var affiliateCount = item.affiliateLocations ? item.affiliateLocations.length : 0;
    if (affiliateCount > 0) {
        if (item.affiliateLocations[0].PhoneNumber) {
            googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_2__/* .findPhoneNumbersInText */ .t)(item.affiliateLocations[0].PhoneNumber, "US");
            phoneNumber = item.affiliateLocations[0].PhoneNumber;
            if (googleNumber.length > 0) {
                googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_3__/* .parsePhoneNumber */ .S)(googleNumber[0].number.number);
                phoneNumber = googleNumber.formatNational();
                googleNumber = googleNumber.getURI();
            }
        }
        serviceArray.push({
            Index: i,
            ServiceId: item.affiliateLocations[0].ServiceId,
            ServiceDescription: item.affiliateLocations[0].ServiceDescription,
            ServiceLabel: "".concat(item.affiliateLocations[0].IsMobile ? "Drivers Available" : "Click to Start"),
            Locations: item.affiliateLocations,
            ServiceURL: item.affiliateLocations[0].AffliateURL,
            iconClassName: "fas fa-link",
            Fee: 0,
            Name: item.affiliateLocations[0].Name,
            ImageUrl: item.affiliateLocations[0].ImageUrl,
            ProviderMessage: item.affiliateLocations[0].Message,
            Reviews: null,
            DisableCart: true,
            FeeMessage: null,
            ButtonLabel: "Get Started",
            PhoneNumber: phoneNumber
        });
        i++;
    }
    if (serviceArray.length > 0 && item.selectedProviderService && (provider != undefined || item.selectedProviderService.provider != undefined)) {
        var myProvider = provider ? provider.providerId : item.selectedProviderService ? item.selectedProviderService.providerId.ProviderId : 0; // Default to first in Array and First Provider and Service ID
        var myServiceId = provider ? provider.serviceId : item.selectedProviderService ? item.selectedProviderService.serviceId : 0;
        var i1 = serviceArray.findIndex(function(el) {
            return el.ServiceId === myServiceId;
        });
        selectedServiceIndex = 0;
        if (i1 >= 0) {
            selectedServiceIndex = i1;
            var j = serviceArray[i1].Locations.findIndex(function(el) {
                return el.ProviderId === myProvider;
            });
            if (j >= 0) {
                item.price = serviceArray[i1].Locations[j].Price;
                // TODO: Add Hourly Rate..
                var mover = serviceArray[i1].Locations[j];
                serviceArray[i1].Locations.splice(j, 1);
                serviceArray[i1].Locations.unshift(mover);
            }
        }
    }
    // TODO: Need to Reformat Service Array Descriptions
    // Resort Service Array by Selected Service Level???
    serviceArray.forEach(function(service, i) {
        switch(service.ServiceId){
            case 0:
                {
                    var quantityLabel = quantityLabelFunc(service.Locations[0]);
                    service.ServiceLabel = "From: ".concat(service.Locations[0].City, ", ").concat(service.Locations[0].State, " ").concat(quantityLabel);
                    break;
                }
            case 1:
                service.ServiceDescription = "".concat(service.Locations[0].ServiceDescription, " in ").concat(service.Locations[0].City), service.ServiceLabel = "".concat((0,_services__WEBPACK_IMPORTED_MODULE_1__/* .getDistanceMessage */ .$h)(service.Locations[0].DistanceMiles));
                break;
            case 2, 3:
                service.iconClassName = "fas fa-shipping-fast";
                break;
            case 4:
                break;
            case 5:
                service.ServiceLabel = "Please Call: ".concat(service.Locations[0].PhoneNumber);
                service.ServiceURL = "Please Call  ".concat(service.Locations[0].PhoneNumber, " ").concat((0,_services__WEBPACK_IMPORTED_MODULE_1__/* .getDistanceMessage */ .$h)(service.Locations[0].DistanceMiles));
                break;
        }
    });
    if (serviceArray.length > 0) {
        item.selectedProviderService = {
            providerId: serviceArray[selectedServiceIndex].Locations[0],
            serviceId: serviceArray[selectedServiceIndex].ServiceId
        };
        if (serviceArray.length > 1 || serviceArray[0].ServiceId != 0) {
            optionalServiceArray = serviceArray;
        }
    }
    return {
        item: item,
        serviceArray: serviceArray,
        selectedServiceIndex: selectedServiceIndex,
        optionalServiceArray: optionalServiceArray
    };
}
function quantityLabelFunc(location) {
    return location.InventoryManaged == 1 ? "Available: ".concat(location.Quantity) : "";
}


/***/ }),

/***/ 59327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ getDistanceMessage; },
/* harmony export */   "I3": function() { return /* binding */ getCartTotal; }
/* harmony export */ });
/* unused harmony exports filter_array, groupByAlpha */
var collator = new Intl.Collator("en", {
    numeric: true,
    sensitivity: "base"
});
var filter_array = function(test_array) {
    var index = -1, arr_length = test_array ? test_array.length : 0, resIndex = -1, result = [];
    while(++index < arr_length){
        var value = test_array[index];
        if (value) {
            result[++resIndex] = value;
        }
    }
    return result;
};
// GroupBy Alphabetics
// Need to Sort Data First - Or it won't necessarily be in order
// Need to Handle not Alpha Characters - 0-9[...]
var groupByAlpha = function(AllData, SortBy) {
    var groupedCollection = {};
    var arr_length = AllData ? AllData.length : 0;
    if (arr_length > 0) {
        AllData.sort(function(a, b) {
            if (SortBy === "Asc") return collator.compare(a.name, b.name);
            else return collator.compare(b.name, a.name);
        });
    }
    for(var i = 0; i < arr_length; i++){
        //loop throug collection
        var firstLetter = AllData[i].name.charAt(0);
        if (groupedCollection[firstLetter] === undefined) {
            groupedCollection[firstLetter] = [];
        }
        groupedCollection[firstLetter].push({
            id: AllData[i].id,
            name: AllData[i].name,
            urlSlug: AllData[i].urlSlug
        });
    }
    return groupedCollection;
};
// ADD in SHIPPING TAX ETC...
var getCartTotal = function(cartItems) {
    var total = 0;
    for(var i = 0; i < cartItems.length; i++){
        if (cartItems[i].price) {
            total += cartItems[i].qty * cartItems[i].price;
        }
    }
    return total;
};
// Make Imperial vs Metric Later...
var getDistanceMessage = function(distance) {
    var total = Math.round(distance, 2);
    var message = "";
    if (total <= 1) {
        message = "< 1 mile away";
    } else {
        message = "".concat(total, " miles away");
    }
    return message;
};


/***/ })

}]);